"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _closeButton = _interopRequireDefault(require("../../close-button"));
require("./styles.css");
var _excluded = ["className"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var OverlayCloseButton = function OverlayCloseButton(_ref) {
  var _ref$closeCallback = _ref.closeCallback,
    closeCallback = _ref$closeCallback === void 0 ? function () {} : _ref$closeCallback,
    _ref$closeModal = _ref.closeModal,
    closeModal = _ref$closeModal === void 0 ? function () {} : _ref$closeModal,
    _ref$closeProps = _ref.closeProps,
    className = _ref$closeProps.className,
    closeButtonProps = _objectWithoutProperties(_ref$closeProps, _excluded),
    _ref$isDarkTheme = _ref.isDarkTheme,
    isDarkTheme = _ref$isDarkTheme === void 0 ? false : _ref$isDarkTheme,
    isDialogVariant = _ref.isDialogVariant,
    isImageVariant = _ref.isImageVariant;
  var closeButtonClasses = (0, _classnames["default"])('sb-overlay__closeBtn color-textBlackSoft', className, {
    absolute: isDialogVariant || isImageVariant
  });
  var button = /*#__PURE__*/_react["default"].createElement(_closeButton["default"], _extends({
    className: closeButtonClasses,
    "data-is-close-button": true,
    highContrast: isImageVariant || isDarkTheme,
    onClick: function onClick() {
      closeModal();
      closeCallback();
    }
  }, closeButtonProps));
  if (isDialogVariant || isImageVariant) {
    return button;
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-right sb-overlay__closeBtnContainer sb-global-gutters"
  }, button);
};
OverlayCloseButton.propTypes = process.env.NODE_ENV !== "production" ? {
  closeCallback: _propTypes["default"].func,
  closeProps: _propTypes["default"].object,
  isImageVariant: _propTypes["default"].bool
} : {};
var _default = exports["default"] = OverlayCloseButton;